import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../contexts/auth";
import { Container, Card, Row, Col, Image, Tabs, Tab } from "react-bootstrap";
import Menu from "../Components/menu";
import ModuloCiclo2026 from "./ciclo_novo"; // Novo componente
import { pegar_dados_aluno, buscaFoto } from "../../services/api";
import "./notas.css";

const PaginaNotas = () => {
    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes'];

    // const matricula_aluno = localStorage.getItem("aluno");
    let { matricula_aluno } = useParams();
    const unidade_aluno = matricula_aluno ? matricula_aluno.substring(0, 2) : "01";
    const ano_atual = "26";

    const [aluno, setAluno] = useState(null);
    const [foto, setFoto] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const carregarDados = async () => {
            try {
                const [respAluno, respFoto] = await Promise.all([
                    pegar_dados_aluno(matricula_aluno),
                    buscaFoto(matricula_aluno)
                ]);
                setAluno(respAluno.data[0]);
                console.log("Dados do aluno:", respAluno.data[0]);
                setFoto(respFoto);

            } catch (error) {
                console.error("Erro ao carregar dados do aluno", error);
            } finally {
                setIsLoading(false);
            }
        };
        carregarDados();
    }, [matricula_aluno]);

    const getSerieFormatada = (aluno) => {
        if (!aluno) return "";
        if (aluno.gra === '1') {
            return `${aluno.ser <= '5' ? 'Fundamental I' : 'Fundamental II'} - ${aluno.ser}º Ano`;
        }
        if (aluno.gra === '2') return `Médio - ${aluno.ser}ª Série`;
        return "";
    };

    if (isLoading) return <div className="vazio">Carregando...</div>;
    if (!aluno || aluno.gra === '0') {
        // if (!aluno || aluno.gra === '0' || (aluno.gra === '1' && Number(aluno.ser) >= 1 && Number(aluno.ser) <= 5)) {
        return <div className="sem-boletim"><p>Boletim não encontrado. Entre em contato com a supervisão.</p></div>;
    }

    return (
        <div className="notas" style={{ border: '8px solid #006CB5', padding: '10px', borderRadius: '8px' }}>
            <div style={{ border: '8px solid #F5821F', padding: '10px', borderRadius: '8px' }}>
                {/* <Menu /> */}
                <Container className="mt-4">
                    <Card border="dark" className="mb-4">
                        <Card.Body>
                            <Card.Title className="mb-4">
                                SANTA MÔNICA REDE DE ENSINO - UNIDADE {unidades[parseInt(unidade_aluno)]?.toUpperCase()}
                            </Card.Title>
                            <Row align="center">
                                <Col md={2} lg={2} className="mb-3">
                                    <Image
                                        src={foto ? `data:image/jpeg;base64,${foto}` : "Images/aluno_novo.png"}
                                        roundedCircle
                                        style={{ width: '120px', height: '120px', objectFit: 'cover', border: '2px solid #F5821F', padding: '1px', borderRadius: '1px' }}
                                    />
                                </Col>
                                <Col md={10} lg={10} className="text-start">
                                    <p><strong>Nome:</strong> {aluno.nome}</p>
                                    <p><strong>Turma:</strong> {aluno.turma}</p>
                                    <p><strong>Série:</strong> {getSerieFormatada(aluno)}</p>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card border="dark">
                        <Card.Body>
                            <Tabs defaultActiveKey="1" id="tabs-boletim" className="mb-3" justify variant="pills">
                                {[1, 2, 3, 4].map((ciclo) => (
                                    <Tab key={ciclo} eventKey={ciclo.toString()} title={`${ciclo}º Ciclo`}>
                                        <ModuloCiclo2026
                                            ciclo={ciclo}
                                            matricula={matricula_aluno}
                                            ano={ano_atual}
                                        />
                                    </Tab>
                                ))}
                            </Tabs>
                        </Card.Body>
                    </Card>
                </Container>
            </div>
        </div>
    );
};

export default PaginaNotas;